 // ARCHIVO AUTO-GENERADO. LOS CAMBIOS SE DESTRUIRÁN.

import {CuentaTipoIds} from './CuentaTipo'
import {Tables} from './Tables'
import {Align} from 'sopix/db/db-types'
import {tableColumns} from 'sopix/db/TableColumns'
import {SimpleColumn} from 'sopix/db/dbColumn'

export const CuentaTipoCol = Object.freeze({
    idTipo : new SimpleColumn(CuentaTipoIds.idTipo, 11, 11, Align.RIGHT),
    tipo : new SimpleColumn(CuentaTipoIds.tipo, 15, 10, Align.LEFT),
})

tableColumns[Tables.CuentaTipo] = CuentaTipoCol
